import React from "react";

const Section = ({
  children,
  className = "",
  id,
  bgColor = "bg-white",
  fullWidth = false,
}) => {
  return (
    <section id={id} className={`py-16 md:py-24 ${bgColor} ${className}`}>
      <div className={fullWidth ? "w-full" : "container"}>{children}</div>
    </section>
  );
};

export default Section;
